import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-icons/font/bootstrap-icons.scss';
import './styles/custom.scss';

// FONTOS: a bundle-t importáld, ebben benne van a Popper is
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

// (opcionális) ha kell neked globálisan is:
(window as any).bootstrap = bootstrap;

import AOS from "aos";
import "aos/dist/aos.css";
// Ambrus Autóház – homepage interactions
// Requires: Bootstrap 5 JS + AOS


// If you want explicit bootstrap import (optional in your bundling):
// import "bootstrap";

function initAOS() {
  AOS.init({
    duration: 650,
    easing: "ease-out",
    once: true,
    offset: 80,
  });
}

function initYear() {
  const el = document.getElementById("yearNow");
  if (el) el.textContent = String(new Date().getFullYear());
}

function initBackToTop() {
  const btn = document.getElementById("backToTop");
  if (!btn) return;

  const toggle = () => {
    const y = window.scrollY || document.documentElement.scrollTop;
    btn.classList.toggle("is-visible", y > 600);
  };

  btn.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  window.addEventListener("scroll", toggle, { passive: true });
  toggle();
}

function initHoverOpenServices() {
  return;
  // Desktopon: hoverre nyissa a szolgáltatás accordeon elemeit (kérés: “ráállunk / kattintunk”)
  const isDesktop = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (!isDesktop) return;

  const root = document.getElementById("servicesAccordion");
  if (!root) return;

  const items = root.querySelectorAll(".accordion-item");
  items.forEach((item) => {
    const btn = item.querySelector(".accordion-button");
    if (!btn) return;

    item.addEventListener("mouseenter", () => {
      if (btn.classList.contains("collapsed")) btn.click();
    });
  });
}

function initCarousels() {
  // Services carousel: gyorsabb pörgés, pause hover
  const svc = document.getElementById("servicesCarousel");
  if (svc && window.bootstrap?.Carousel) {
    const c = window.bootstrap.Carousel.getOrCreateInstance(svc, {
      interval: 3800,
      ride: "carousel",
      pause: "hover",
      touch: true,
    });
    // no-op; instance created
    void c;
  }

  const gal = document.getElementById("galleryCarousel");
  if (gal && window.bootstrap?.Carousel) {
    const c = window.bootstrap.Carousel.getOrCreateInstance(gal, {
      interval: 4500,
      ride: "carousel",
      pause: "hover",
      touch: true,
    });
    void c;
  }
}

function animateCountUp(el, to, durationMs = 900) {
  const from = 0;
  const start = performance.now();

  const step = (t) => {
    const p = Math.min(1, (t - start) / durationMs);
    const val = Math.round(from + (to - from) * p);
    el.textContent = String(val);
    if (p < 1) requestAnimationFrame(step);
  };

  requestAnimationFrame(step);
}

function initStatsCounter() {
  const els = Array.from(document.querySelectorAll("[data-count]"));
  if (!els.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target;
        const to = Number(el.getAttribute("data-count") || "0");
        animateCountUp(el, to);
        io.unobserve(el);
      });
    },
    { threshold: 0.35 }
  );

  els.forEach((el) => io.observe(el));
}

function initScrollSpyRefresh() {
  // Scrollspy néha igényel refresh-t, ha képek betöltése után változik a layout.
  const main = document.querySelector("main[data-bs-spy='scroll']");
  if (!main || !window.bootstrap?.ScrollSpy) return;

  const spy = window.bootstrap.ScrollSpy.getOrCreateInstance(main, {
    target: ".navbar",
    offset: 90,
  });

  const refresh = () => spy.refresh();
  window.addEventListener("load", refresh, { once: true });
  window.addEventListener("resize", refresh, { passive: true });
}
function initGalleryLightbox() {
  const grid = document.querySelector(".gallery-grid");
  const modalEl = document.getElementById("galleryLightbox");
  const carouselEl = document.getElementById("galleryLightboxCarousel");

  if (!grid || !modalEl || !carouselEl || !window.bootstrap) return;

  const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl, { backdrop: true });
  const carousel = window.bootstrap.Carousel.getOrCreateInstance(carouselEl, {
    interval: false,
    ride: false,
    touch: true,
  });

  grid.addEventListener("click", (e) => {
    const a = e.target.closest(".gallery-item");
    if (!a) return;
    e.preventDefault();

    const idx = Number(a.getAttribute("data-gallery-index") || "0");
    modal.show();

    // várunk egy frame-et, hogy biztosan renderelve legyen
    requestAnimationFrame(() => {
      carousel.to(idx);
    });
  });

  // billentyűzet: bal/jobb nyíl a lapozásra, ha a modal nyitva van
  modalEl.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") carousel.prev();
    if (e.key === "ArrowRight") carousel.next();
  });

  // fókusz a modalra, hogy a keydown működjön
  modalEl.addEventListener("shown.bs.modal", () => {
    modalEl.focus();
  });
}
function initContactForm() {
  const form = document.getElementById("contactForm");
  const resetBtn = document.getElementById("contactResetBtn");
  const status = document.getElementById("contactStatus");
  const submitBtn = document.getElementById("contactSubmitBtn");

  if (!form) return;

  const setStatus = (msg, kind) => {
    if (!status) return;
    status.textContent = msg || "";
    status.classList.remove("text-success", "text-danger", "text-muted");
    if (kind) status.classList.add(kind);
  };

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    // Bootstrap-style validation
    if (!form.checkValidity()) {
      form.classList.add("was-validated");
      setStatus("Kérlek ellenőrizd a megadott adatokat.", "text-danger");
      return;
    }

    // Frontend-only demo submit (cseréld majd backend hívásra)
    submitBtn?.setAttribute("disabled", "disabled");
    setStatus("Üzenet küldése…", "text-muted");

    window.setTimeout(() => {
      submitBtn?.removeAttribute("disabled");
      setStatus("Köszönjük! Az üzenet rögzítve (demo). Backend bekötés után ez valódi lesz.", "text-success");
      form.reset();
      form.classList.remove("was-validated");
    }, 650);
  });

  resetBtn?.addEventListener("click", () => {
    form.reset();
    form.classList.remove("was-validated");
    setStatus("");
  });
}
function initPartnersCarousel() {
  const el = document.getElementById("partnersCarousel");
  if (!el || !window.bootstrap?.Carousel) return;

  window.bootstrap.Carousel.getOrCreateInstance(el, {
    interval: 2600,
    pause: "hover",
    touch: true,
    ride: "carousel",
  });
}
function initReviewsWheel() {
  const root = document.getElementById("reviewsWheel");
  if (!root) return;

  const slots = {
    m2: root.querySelector(".review-slot.slot--2"),
    m1: root.querySelector(".review-slot.slot--1"),
    c0: root.querySelector(".review-slot.slot--0"),
    p1: root.querySelector(".review-slot.slot--p1"),
    p2: root.querySelector(".review-slot.slot--p2"),
  };

  const prevBtn = document.getElementById("rwPrev");
  const nextBtn = document.getElementById("rwNext");
  const counter = document.getElementById("rwCounter");

  if (!slots.m2 || !slots.m1 || !slots.c0 || !slots.p1 || !slots.p2 || !counter) return;

  // 1) Vélemények beolvasása HTML-ből
  const sourceItems = Array.from(root.querySelectorAll(".reviews-source .review-item"));

  const reviews = sourceItems
    .map((item) => {
      const textEl = item.querySelector(".review-text");
      const nameEl = item.querySelector(".review-name");
      const metaEl = item.querySelector(".review-meta");

      const text = (textEl?.textContent || "").trim();
      const name = (nameEl?.textContent || "").trim();
      const meta = (metaEl?.textContent || "").trim();

      if (!text || !name) return null;

      return { text, name, meta };
    })
    .filter(Boolean);

  if (!reviews.length) {
    // nincs adat -> ne törjön el a layout
    slots.c0.innerHTML = `
      <div class="quote-mark">“</div>
      <div class="review-text">Hamarosan érkeznek ügyfélvélemények.</div>
      <div class="review-footer">
        <div class="review-name">Ambrus Autóház</div>
        <div class="review-meta"></div>
      </div>
    `;
    counter.textContent = "0 / 0";
    prevBtn?.setAttribute("disabled", "disabled");
    nextBtn?.setAttribute("disabled", "disabled");
    return;
  }

  const mod = (i, n) => (i % n + n) % n;
  let index = 0;
  let isAnimating = false;

  const escapeHtml = (s) =>
    String(s)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const tpl = (r) => `
    <div class="quote-mark">“</div>
    <div class="review-text">${escapeHtml(r.text)}</div>
    <div class="review-footer">
      <div class="review-name">${escapeHtml(r.name)}</div>
      <div class="review-meta">${escapeHtml(r.meta || "")}</div>
    </div>
  `;

  const render = () => {
    const n = reviews.length;
    slots.m2.innerHTML = tpl(reviews[mod(index - 2, n)]);
    slots.m1.innerHTML = tpl(reviews[mod(index - 1, n)]);
    slots.c0.innerHTML = tpl(reviews[index]);
    slots.p1.innerHTML = tpl(reviews[mod(index + 1, n)]);
    slots.p2.innerHTML = tpl(reviews[mod(index + 2, n)]);
    counter.textContent = `${index + 1} / ${n}`;
  };

  const rotateNext = () => {
    const tmp = slots.m2;
    slots.m2 = slots.m1;
    slots.m1 = slots.c0;
    slots.c0 = slots.p1;
    slots.p1 = slots.p2;
    slots.p2 = tmp;
  };

  const rotatePrev = () => {
    const tmp = slots.p2;
    slots.p2 = slots.p1;
    slots.p1 = slots.c0;
    slots.c0 = slots.m1;
    slots.m1 = slots.m2;
    slots.m2 = tmp;
  };

  const applySlotClasses = () => {
    const all = root.querySelectorAll(".review-slot");
    all.forEach((el) => {
      el.classList.remove("slot--2", "slot--1", "slot--0", "slot--p1", "slot--p2");
    });

    slots.m2.classList.add("slot--2");
    slots.m1.classList.add("slot--1");
    slots.c0.classList.add("slot--0");
    slots.p1.classList.add("slot--p1");
    slots.p2.classList.add("slot--p2");
  };

  const step = (dir) => {
    if (isAnimating || reviews.length <= 1) return;
    isAnimating = true;

    if (dir > 0) {
      index = mod(index + 1, reviews.length);
      rotateNext();
    } else {
      index = mod(index - 1, reviews.length);
      rotatePrev();
    }

    applySlotClasses();

    window.setTimeout(() => {
      render();
      isAnimating = false;
    }, 270);
  };

  const goPrev = () => step(-1);
  const goNext = () => step(1);

  prevBtn?.addEventListener("click", goPrev);
  nextBtn?.addEventListener("click", goNext);

  root.addEventListener("keydown", (e) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      goPrev();
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      goNext();
    }
  });

  let wheelLock = false;
  root.addEventListener(
    "wheel",
    (e) => {
      if (wheelLock) return;
      if (Math.abs(e.deltaY) < 12) return;

      e.preventDefault();
      wheelLock = true;

      if (e.deltaY > 0) goNext();
      else goPrev();

      window.setTimeout(() => (wheelLock = false), 320);
    },
    { passive: false }
  );

  // init
  render();
  applySlotClasses();
}

document.addEventListener("DOMContentLoaded", () => {
  initAOS();
  initYear();
  initBackToTop();
  initHoverOpenServices();
  initCarousels();
  initStatsCounter();
  initScrollSpyRefresh();
  initGalleryLightbox();
  initContactForm();
  initPartnersCarousel();
  initReviewsWheel();
});
